/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/display-name */
import React, {
  Dispatch,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import { Button, Col, Form, Input, Row, Select, Table } from 'antd'
import { SelectValue } from 'antd/lib/select'
import ID_COMPONENTE from 'config/idComponente'
import MACRO_CODIGO from 'config/macroCodigo'
import TIPO_MACRO from 'config/tipoMacro'
import TIPO_USUARIO from 'config/tipoUsuario'
import { ApplicationContext } from 'Context'
import buscaAgendamentoMultiplo from 'Helpers/agendamentoMultiplo'
import { IPerfil, Roles } from 'Models/auth'
import { IHorario, IMacro } from 'Models/docas'
import { STATUS_HORARIOS } from 'Models/docas/IHorario'
import moment from 'moment'
import WsDocasService from 'Services/WS_DOCAS'
import { ServiceListResponse } from 'Types/ServiceResponse'

import { DocasContext } from '../Context/context'

interface IProps {
  macros: IMacro[]
  horario: IHorario
  horarioDetalhes: IHorario | undefined
  setHorarioDetalhes: Dispatch<SetStateAction<IHorario | undefined>>
  setLoading: Dispatch<SetStateAction<boolean>>
  cdMacroTipo?: number
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}
const MacrosDetalhes = ({
  macros,
  horario,
  horarioDetalhes,
  setHorarioDetalhes,
  setLoading,
  cdMacroTipo,
  atualizaAgenda,
}: IProps): ReactElement => {
  const [formulario] = Form.useForm()
  const [envia, setEnvia] = useState<boolean>(false)
  const [macro, setMacro] = useState<number>()
  const [listaMacros, setListaMacros] = useState<IMacro[]>([])
  const [selectMacroItens, setSelectMacroItens] = useState<IMacro[]>([])
  const [justificativa, setJustificativa] = useState<string>('')
  const [justificativaObrigatoria, setJustificativaObrigatoria] = useState<
    boolean | undefined
  >(true)
  const [temMacro, setTemMacro] = useState<boolean>(horario.temMacro)
  const { applicationContext } = useContext(ApplicationContext)
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { Option } = Select
  const [emitindoMacro, setEmitindoMacro] = useState<boolean>(false)

  useEffect(() => {
    if (macros) {
      setSelectMacroItens(macros)
    }
  }, [])

  useEffect(() => {
    if (horarioDetalhes) {
      setListaMacros(horarioDetalhes.macrosCandidato)
    }
  }, [horarioDetalhes])

  useEffect(() => {
    if (cdMacroTipo === TIPO_MACRO.AVANCADO) {
      let proximasMacros: IMacro[] = []
      const gruposUsuario: number[] | undefined =
        applicationContext.usuarioAtual?.perfis.map((role: IPerfil) => role.id)

      if (listaMacros.length > 0) {
        const ultimaMacro: IMacro | undefined = getUltimaMacro()

        if (ultimaMacro) {
          proximasMacros = macros.filter((f) =>
            ultimaMacro.listCdMacroProxima.includes(f.cdMacro!),
          )
        }
      } else {
        proximasMacros = macros.filter((f) => f.primeiraMacro)
      }

      if (gruposUsuario) {
        for (let i = 0; i < proximasMacros.length; i++) {
          let removeMacro = true

          for (
            let j = 0;
            j < proximasMacros[i].listIdRolesEmissao.length;
            j++
          ) {
            if (
              gruposUsuario.includes(proximasMacros[i].listIdRolesEmissao[j])
            ) {
              removeMacro = false
              break
            }
          }

          if (removeMacro) {
            proximasMacros = proximasMacros.filter(
              (f) => f.cdMacro !== proximasMacros[i].cdMacro,
            )
          }
        }
      }

      setSelectMacroItens(proximasMacros)
    }
  }, [listaMacros])

  const getUltimaMacro = () => {
    let ultimaMacro: IMacro | undefined = undefined

    for (let i = listaMacros.length - 1; i >= 0 && !ultimaMacro; i--) {
      if (listaMacros[i].cdMacro !== MACRO_CODIGO.OUTROS) {
        ultimaMacro = listaMacros[i]
      }
    }

    if (ultimaMacro) {
      const proximasMacros: number[] | undefined = macros.find(
        (f) => f.cdMacro === ultimaMacro!.cdMacro,
      )?.listCdMacroProxima

      if (proximasMacros) {
        ultimaMacro.listCdMacroProxima = proximasMacros
      }
    }

    return ultimaMacro
  }

  const handleChangeMacro = (value: SelectValue) => {
    const cdMacro = value as number

    setMacro(cdMacro)
    setJustificativaObrigatoria(
      macros.find((f) => f.cdMacro === cdMacro)?.justObrigatoria,
    )

    if (justificativa.length >= 20 && value) {
      setEnvia(true)
    } else {
      setEnvia(false)
    }
  }

  const handleChangeJustificativa = (e: {
    target: { value: React.SetStateAction<string> }
  }) => {
    setJustificativa(e.target.value.toString().trimStart())
    if (e.target.value.toString().trimStart().length >= 20 && macro) {
      setEnvia(true)
    } else {
      setEnvia(false)
    }
  }

  const executaMacro = async () => {
    if (macro) {
      setEnvia(false)
      setEmitindoMacro(true)

      const agendamentoMultiplo = buscaAgendamentoMultiplo(
        horario,
        docasContext.agendamentosMultiplos,
      )
      const horarioPrincipal =
        agendamentoMultiplo && agendamentoMultiplo.horarios.length > 1
          ? agendamentoMultiplo.horarios[0]
          : horario

      const { data } = await WsDocasService.macro.executaMacro(
        ID_COMPONENTE.DOCAS,
        {
          cdArmazem: docasContext.cdArmazemAtual,
          cdHorario: horarioPrincipal.cdAgendamentoDocasHorario,
          cdCandidato: horarioPrincipal.cdCandidatoAgendamento,
          cdMacro: macro,
          justificativa,
          placaVeiculo: horario.placa,
          transportadora: horario.nomeEntidade,
          cdEntidade: horario.cdEntidade,
          cdVeiculo: horario.cdVeiculo,
          cdViagem: horario.cdViagem,
        },
      )

      if (data.message !== 'Sucesso') {
        window.alert(`Erro no registro de macro. ${data.message}`)
      }

      atualizaAgenda()

      const getDetalhes = async (corMacro: string | undefined) => {
        setLoading(true)
        const { data } = await WsDocasService.agenda.getDetalhes(
          ID_COMPONENTE.DOCAS,
          horario.cdAgendamentoDocasHorario,
        )

        const detalhes = data.data

        if (detalhes) {
          detalhes.temMacro = true
          detalhes.corMacro = corMacro
          setHorarioDetalhes(detalhes)
        }

        setLoading(false)
      }

      let corMacro

      if (macro !== MACRO_CODIGO.OUTROS) {
        corMacro = macros.find((f) => f.cdMacro === macro)?.corMacro
      } else {
        const ultimaMacro = getUltimaMacro()
        corMacro = ultimaMacro
          ? macros.find((f) => f.cdMacro === ultimaMacro.cdMacro)?.corMacro
          : macros.find((f) => f.cdMacro === macro)?.corMacro
      }

      getDetalhes(corMacro)
      setMacro(undefined)
      setJustificativa('')

      if (!temMacro) {
        setTemMacro(true)
      }

      const atualizacaoHorarios = agendamentoMultiplo
        ? atualizaCorMacroAgendamentoMultiplo(
            agendamentoMultiplo.horarios.map(
              (m) => m.cdAgendamentoDocasHorario,
            ),
            corMacro,
          )
        : docasContext.horarios!
      const atualizacaoHorario = atualizacaoHorarios.find(
        (f) =>
          f.cdAgendamentoDocasHorario ===
          horarioPrincipal.cdAgendamentoDocasHorario,
      )!

      if (macro !== MACRO_CODIGO.OUTROS) {
        atualizacaoHorario.cdMacroExcetoOutros = macro
        atualizacaoHorario.cdMacroUsuarioExcetoOutros =
          applicationContext.usuarioAtual!.cdUsuario
      }

      atualizacaoHorario.cdMacro = macro
      atualizacaoHorario.cdMacroUsuario =
        applicationContext.usuarioAtual!.cdUsuario
      atualizacaoHorario.temMacro = true
      atualizacaoHorario.corMacro = corMacro

      const i = atualizacaoHorarios.findIndex(
        (f) =>
          f.cdAgendamentoDocasHorario ==
          atualizacaoHorario.cdAgendamentoDocasHorario,
      )
      atualizacaoHorarios[i] = atualizacaoHorario

      const atualizacaoDocasContext = {
        ...docasContext,
        horarios: atualizacaoHorarios,
      }

      if (cdMacroTipo === TIPO_MACRO.AVANCADO && !docasContext.avisoPiscante) {
        atualizacaoDocasContext.atualizarAvisoPiscante = true
      }

      setDocasContext(atualizacaoDocasContext)
      setEmitindoMacro(false)
    }
  }

  const atualizaCorMacroAgendamentoMultiplo = (
    cdHorarios: number[],
    corMacro?: string,
  ) => {
    const atualizacaoHorarios = docasContext.horarios!

    for (let j = 0; j < cdHorarios.length; j++) {
      const i = atualizacaoHorarios.findIndex(
        (f) => f.cdAgendamentoDocasHorario == cdHorarios[j],
      )
      atualizacaoHorarios[i].corMacro = corMacro
    }

    return atualizacaoHorarios
  }

  return (
    <>
      {!cdMacroTipo ||
      cdMacroTipo !== 4 ||
      (cdMacroTipo === 4 &&
        selectMacroItens.length > 0 &&
        (!temMacro || horario.horarioStatus === STATUS_HORARIOS.APROVADO)) ? (
        <Form form={formulario} layout="vertical">
          <Row gutter={5} style={{ background: '#f5f5f5' }}>
            <Col span={8}>
              <Form.Item label="Macro:" required tooltip="Campo obrigatório">
                <Select
                  style={{ width: '100%' }}
                  onChange={handleChangeMacro}
                  value={macro}
                >
                  {selectMacroItens.length > 0
                    ? selectMacroItens.map((m) => (
                        <Option key={m.cdMacro} value={m.cdMacro!}>
                          {m.nome!}
                        </Option>
                      ))
                    : []}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Justificativa:"
                required={justificativaObrigatoria}
                tooltip={
                  justificativaObrigatoria
                    ? 'Campo obrigatório, mínimo 20 caracteres'
                    : undefined
                }
              >
                <Input
                  type="text"
                  minLength={20}
                  value={justificativa}
                  onChange={handleChangeJustificativa}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Button
                style={{ marginTop: '30px' }}
                disabled={!envia && justificativaObrigatoria}
                type="primary"
                onClick={() => executaMacro()}
                loading={emitindoMacro}
              >
                Emitir macro
              </Button>
            </Col>
          </Row>
        </Form>
      ) : selectMacroItens.length === 0 ? (
        applicationContext.usuarioAtual?.perfis.some(
          (s) => s.id === TIPO_USUARIO.GESTOR_DOCAS,
        ) ? (
          <div>O seu usuário não está habilitado para emitir macros.</div>
        ) : (
          <div>
            Aguarde um usuário do grupo{' '}
            {applicationContext.usuarioAtual?.perfis.some(
              (s) => s.id === TIPO_USUARIO.EXPEDICAO,
            )
              ? 'Portaria'
              : 'Expedição'}{' '}
            emitir uma nova macro.
          </div>
        )
      ) : horario.horarioStatus !== STATUS_HORARIOS.APROVADO ? (
        applicationContext.usuarioAtual?.perfis.some(
          (s) =>
            s.id === TIPO_USUARIO.EXPEDICAO ||
            s.id === TIPO_USUARIO.GESTOR_DOCAS,
        ) ? (
          <div>
            É necessário aprovar o agendamento antes de emitir a próxima macro.
          </div>
        ) : (
          <div>
            Aguarde um usuário do grupo Expedição aprovar o agendamento.
          </div>
        )
      ) : (
        <div>
          O fluxo de macros já foi concluído, não é possível emitir novas
          macros.
        </div>
      )}
      <Row>
        <Col>
          <Table
            columns={[
              {
                title: 'Macro',
                dataIndex: 'nome',
                key: 'nome',
              },
              {
                title: 'Data/Hora',
                dataIndex: 'data',
                key: 'data',
              },
              {
                title: 'Usuário',
                dataIndex: 'usuarioNome',
                key: 'usuarioNome',
                render: (text: string) => <span>{text}</span>,
              },
              {
                title: 'Justificativa',
                dataIndex: 'justificativa',
                key: 'justificativa',
                render: (text: string) => <span>{text}</span>,
              },
            ]}
            dataSource={listaMacros}
            pagination={false}
            size="small"
            sticky
            scroll={{ y: 350 }}
          />
        </Col>
      </Row>
    </>
  )
}

export default MacrosDetalhes
